/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

export default {
    SAVE_DASHBOARD_STATE: 'saveDashboardState',
    TOGGLE_PREVIEW_MODE: 'togglePreviewMode',
    OPEN_FILTER_MANAGER: 'openFilterManager',
    SESSION_EXPIRED: 'sessionExpired'
};